import {
  PaginationButtons, TableBodyContainer,
  TableBodyLine, TableContainer,
  TableHeader
} from '@touche-lts/panel-ui/dist';
import cl from 'classnames';
import { PictureNameLine } from 'components';
import { observer } from 'mobx-react-lite';
import { CustomersTableSortProps } from 'mobx-stores/customers/customers-table/customers-table-store.types';
import { useRootStore } from 'mobx-stores/store-provider';
import moment from 'moment';
import { useEffect } from 'react';
import { columnTableWidths } from './customers-table.utils'
import styles from '../customers-page.module.scss'
import { useGetScrollWidth } from 'hooks/custom-hooks';

const CustomersTableComponent = (props) => {
  const { className, style } = props

  const {
    customersTableStore: {
      triggerSearch,
      searchResults,
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      paginationInfo,
      genderSelect,
      formatPhoneNumber,
      formatFullname,
      onPageSelect
    },
    routingStore: { push }
  } = useRootStore()

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
  }, [triggerSearch])

  const {scrollX, handleScroll} = useGetScrollWidth()
  return (
    <TableContainer className={cl(className, styles.thinScroll)} style={style} onScroll={handleScroll}>
      <TableHeader
        tableColumns={[
          {
            label: 'customers',
            // widthPercentage: columnTableWidths.customers,
            widthPx: columnTableWidths.customers,
            isColumnMarked: isColumnMarked(CustomersTableSortProps.FIRST_NAME),
            sortDirection: getSortDirection(CustomersTableSortProps.FIRST_NAME),
            setSortDirection: handleSortDirectionChange(
              CustomersTableSortProps.FIRST_NAME
            ),
            inputProps: {
              placeholder: 'Search...',
              value: searchProps.fullName,
              onChange: fullName => onSearchPropsChange({ fullName })
            }
          },
          {
            label: 'email',
            // widthPercentage: columnTableWidths.emailAddress,
            widthPx: columnTableWidths.emailAddress,
            isColumnMarked: isColumnMarked(CustomersTableSortProps.EMAIL),
            sortDirection: getSortDirection(CustomersTableSortProps.EMAIL),
            setSortDirection: handleSortDirectionChange(
              CustomersTableSortProps.EMAIL
            ),
            inputProps: {
              placeholder: 'Search...',
              value: searchProps.emailAddress,
              onChange: emailAddress => onSearchPropsChange({ emailAddress })
            }
          },
          {
            label: 'phone number',
            // widthPercentage: columnTableWidths.phoneNumber,
            widthPx: columnTableWidths.phoneNumber,
            isColumnMarked: isColumnMarked(CustomersTableSortProps.PHONE_NUMBER),
            sortDirection: getSortDirection(CustomersTableSortProps.PHONE_NUMBER),
            setSortDirection: handleSortDirectionChange(
              CustomersTableSortProps.PHONE_NUMBER
            ),
            inputProps: {
              placeholder: 'Search...',
              value: searchProps.phoneNumber,
              onChange: phoneNumber => onSearchPropsChange({ phoneNumber })
            }
          },
          {
            label: 'date of birth',
            // widthPercentage: columnTableWidths.dateOfBirth,
            widthPx: columnTableWidths.dateOfBirth,
            isColumnMarked: isColumnMarked(CustomersTableSortProps.DATE_OF_BIRTH),
            sortDirection: getSortDirection(CustomersTableSortProps.DATE_OF_BIRTH),
            setSortDirection: handleSortDirectionChange(
              CustomersTableSortProps.DATE_OF_BIRTH
            ),
            periodFilterProps: {
              placeholder: "From - To",
              period: searchProps.dateOfBirth,
              setPeriod: dateOfBirth => onSearchPropsChange({ dateOfBirth }),
            },
          },
          {
            label: 'gender',
            // widthPercentage: columnTableWidths.gender,
            widthPx: columnTableWidths.gender,
            isColumnMarked: isColumnMarked(CustomersTableSortProps.GENDER),
            sortDirection: getSortDirection(CustomersTableSortProps.GENDER),
            setSortDirection: handleSortDirectionChange(
              CustomersTableSortProps.GENDER
            ),
            selectProps: {
              noneLabel: 'All',
              options: genderSelect,
              value: searchProps.gender,
              onChange: gender => onSearchPropsChange({ gender })
            },
          },
          {
            label: 'registered on',
            // widthPercentage: columnTableWidths.registeredDate,
            widthPx: columnTableWidths.registeredDate,
            isColumnMarked: isColumnMarked(CustomersTableSortProps.REGISTERED_DATE),
            sortDirection: getSortDirection(CustomersTableSortProps.REGISTERED_DATE),
            setSortDirection: handleSortDirectionChange(
              CustomersTableSortProps.REGISTERED_DATE
            ),
            periodFilterProps: {
              placeholder: "From - To",
              period: searchProps.registeredOn,
              setPeriod: registeredOn => onSearchPropsChange({ registeredOn }),
            },
          },
          {
            label: 'Total Revenue',
            // widthPercentage: columnTableWidths.totalRevenue,
            widthPx: columnTableWidths.totalRevenue,
            isColumnMarked: isColumnMarked(CustomersTableSortProps.REVENUE_TOTAL),
            sortDirection: getSortDirection(CustomersTableSortProps.REVENUE_TOTAL),
            setSortDirection: handleSortDirectionChange(
              CustomersTableSortProps.REVENUE_TOTAL
            ),
            sliderFilterProps: {
              label: 'usd',
              min: 0,
              max: 1000,
              value: [searchProps.revenueTotalMin, searchProps.revenueTotalMax],
              onChange: ([revenueTotalMin, revenueTotalMax]) =>
                onSearchPropsChange({ revenueTotalMin, revenueTotalMax })
            }
          },
        ]}
      />
      <TableBodyContainer className={styles.tableBodyContainer}>
        {searchResults?.map(customerAggregate => {
          return (
            <TableBodyLine
              key={customerAggregate.id}
              style={{ cursor: 'pointer' }}
              onClick={() => push('/customers/' + customerAggregate.customer.id)}
              cells={[
                {
                  // widthPercentage: columnTableWidths.customers,
                  widthPx: columnTableWidths.customers,
                  children: (
                    <PictureNameLine
                      imageSrc={customerAggregate.customer.imageUrl}
                      imageBoxShadow
                      name={formatFullname(customerAggregate?.customer?.firstName, customerAggregate?.customer?.lastName)}
                    />
                  )
                },
                {
                  // widthPercentage: columnTableWidths.emailAddress,
                  widthPx: columnTableWidths.emailAddress,
                  children: <span>{customerAggregate?.customer.email}</span>
                },
                {
                  // widthPercentage: columnTableWidths?.phoneNumber,
                  widthPx: columnTableWidths.phoneNumber,
                  children: <span>{formatPhoneNumber(customerAggregate.customer?.phone)}</span>
                },
                {
                  // widthPercentage: columnTableWidths.dateOfBirth,
                  widthPx: columnTableWidths.dateOfBirth,
                  children: <span> {customerAggregate.customer.birth ? moment(customerAggregate.customer?.birth).format('DD.MM.YYYY') : ' '}</span>
                },
                {
                  // widthPercentage: columnTableWidths.gender,
                  widthPx: columnTableWidths.gender,
                  children: <span>{customerAggregate?.customer.gender}</span>
                },
                {
                  // widthPercentage: columnTableWidths.registeredDate,
                  widthPx: columnTableWidths.registeredDate,
                  children: <span>{moment(customerAggregate.customer.registeredDate).format('DD.MM.YYYY')}</span>
                },
                {
                  // widthPercentage: columnTableWidths.totalRevenue,
                  widthPx: columnTableWidths.totalRevenue,
                  children: <span>${customerAggregate.revenueTotal}</span>
                },
              ]}
            />
          )
        })}
      </TableBodyContainer>
      <PaginationButtons alwaysShow {...paginationInfo} onPageSelect={onPageSelect} style={{width : scrollX}}
 />
    </TableContainer>
  )
},

  CustomersTable = observer(CustomersTableComponent)
export { CustomersTable };
